import './commentCard.scss';
import { ReactComponent as accountCircle } from '../../../../../icons/account_circle.svg';
import { ReactComponent as event } from '../../../../../icons/event.svg';
import { AdditionalIcon } from "../../../../../components/shared/additionalIcon/additionalIcon";
import { iconStyle, stylizationVerticalAlign } from "../../../../../components/shared/stylization";
import ButtonField from "../../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../../components/shared/button/types/buttonProps";
import { ButtonFieldProps } from "../../../../../components/buttonField/types/buttonFieldProps";
import { ReactComponent as edit } from '../../../../../icons/edit.svg';
import { ReactComponent as deleteIcon } from '../../../../../icons/delete.svg';
import { formattedDate } from '../../../../../helpers/dateHelper';
import { useContext, useState } from 'react';
import AuthContext from '../../../../../contexts/authContext';
import TextAreaField from '../../../../../components/textAreaField/textAreaField';
import { TextAreaFieldProps } from '../../../../../components/textAreaField/types/textAreaFieldProps';
import KrFormContext, { FormComment } from '../../../../../contexts/krFormContext';
import { SecondaryCommentCardProps } from './types/secondaryCommentCardProps';

const SecondaryCommentCard = (props: SecondaryCommentCardProps) => {
    const { username } = useContext(AuthContext);
    const { krForm, setkrForm } = useContext(KrFormContext);
    const [showEditNewCommentField, setShowEditNewCommentField] = useState<boolean>(false);
    const [showReplyField, setShowReplyField] = useState<boolean>(false);
    const [newCommentContent, setNewCommentContent] = useState<string>("");
    const [disableBtn, setDisableBtn] = useState<boolean>(true);
    
    const getBtnProps = (onClick: any, btnClass: string, placeholder: string, icon: any, disable: boolean): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${btnClass} filterBtn body-txt-medium`,
                style: {
                    height: "40px"
                },
                disabled: disable
            },
            placeHolder: placeholder,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: "auto"
                }
            }
        }
    }

    var textareaProps: TextAreaFieldProps = {
        textAreaPlaceholder: "Wpisz komentarz",
        type: "text",
        keepPristine: true,
        value: newCommentContent,
        setValue: (value: any) => {
            setNewCommentContent(value);
        },
        onFill: (isFill: boolean) => {
            setDisableBtn(!isFill);
        },
        textareaSharedProps: {
            style: {
                height: "200px"
            }
        }
    }

    const handleDeleteCommentClick = () => {
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = form.formComments.filter((item: FormComment) => item.localUUID !== props.secondaryComment?.localUUID);
        form.formComments = newComments;
        setkrForm(form);
    }

    const handleEditCommentClick = () => {
        setNewCommentContent(props.secondaryComment?.tresc!);
        setShowEditNewCommentField(true);
    }

    const handleReplyClick = () => {
        setNewCommentContent("");
        setShowReplyField(true);
    }

    const handleCancelEditCommentClick = () => {
        setShowEditNewCommentField(false);
    }

    const handleCancelReplyClick = () => {
        setShowReplyField(false);
    }

    const handleConfirmEditCommentClick = () => {
        setShowEditNewCommentField(false);
        var editedComment: FormComment = {...props.secondaryComment};
        editedComment.tresc = newCommentContent;
        
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = form.formComments.map((item: FormComment) => item.localUUID === editedComment.localUUID ? editedComment : item );
        form.formComments = newComments;
        setkrForm(form);
    }

    const handleConfirmReplyClick = () => {
        var newComment: FormComment = {
            poczekalniA_ID: krForm.waitingRoomId,
            atrybuT_KOMENTOWANY: props.secondaryComment?.atrybuT_KOMENTOWANY,
            datA_KOMENTARZA: new Date().getTime(),
            tresc: newCommentContent,
            autor: username,
            czY_POPRAWIONE: 0,
            komentarZ_GID: props.secondaryComment?.komentarZ_GID,
            localUUID: crypto.randomUUID()
        }
        setShowReplyField(false);
        
        var form: any = Object.assign({}, krForm);
        var newComments: FormComment[] = [...form.formComments, newComment]
        form.formComments = newComments;
        setkrForm(form);
    }

    return (
        <div className={`${showReplyField ? "secondaryCommentReplyCard" : "secondaryCommentCard"}`}>
            <div>
                <div className="commentInfoPanel boldBtnText">
                    <div className="commentInfoBtns body-txt-medium">{AdditionalIcon(accountCircle, iconStyle)} <span>autor</span> {props.secondaryComment?.autor?.replace(".", " ")}</div>
                    <div className="commentInfoBtns body-txt-medium">{AdditionalIcon(event, iconStyle)} <span>data</span> {formattedDate(new Date(new Date(props.secondaryComment?.datA_KOMENTARZA)))}</div>
                </div>
                <div className="commentText body-txt-large">
                    {props.secondaryComment?.tresc}
                </div>
                {showReplyField &&
                    <TextAreaField {...textareaProps}/>
                }
            </div>
            {props.isLast && 
                <>
                    {props.secondaryComment?.autor === username &&
                        <>
                            {!showEditNewCommentField &&
                                <div className="commentInfoPanel">
                                    <div className="commentActionBtns">
                                        <ButtonField {...getBtnProps(handleEditCommentClick, classNameBtn.SmallPrimaryGray, "", edit, false)}></ButtonField>
                                        <ButtonField {...getBtnProps(handleDeleteCommentClick, classNameBtn.SmallPrimaryGray, "", deleteIcon, false)}></ButtonField>                       
                                    </div>
                                </div>
                            }
                            {showEditNewCommentField && 
                            <>
                                <div>
                                    <TextAreaField {...textareaProps}/>
                                </div>
                                <div className='commentInfoPanel'>
                                    <div className="commentActionBtns" style={{paddingBottom: "20px"}}>
                                        <ButtonField {...getBtnProps(handleCancelEditCommentClick, classNameBtn.SmallSecondary, "Anuluj", undefined, false)}></ButtonField>   
                                        <ButtonField {...getBtnProps(handleConfirmEditCommentClick, classNameBtn.Small, "Dodaj komentarz", undefined, disableBtn)}></ButtonField>
                                    </div>
                                </div>
                            </>
                            }
                        </>
                    }
                    {props.secondaryComment?.autor !== username &&
                        <div className="commentInfoPanel">
                            <div className="commentActionBtns">
                                {!showReplyField && props.primaryComment?.comments?.length! < 6 &&
                                    <ButtonField {...getBtnProps(handleReplyClick, classNameBtn.Small, "Odpowiedz", undefined, false)}></ButtonField> 
                                }                     
                                {showReplyField &&
                                    <>
                                        <ButtonField {...getBtnProps(handleCancelReplyClick, classNameBtn.SmallSecondary, "Anuluj", undefined, false)}></ButtonField>   
                                        <ButtonField {...getBtnProps(handleConfirmReplyClick, classNameBtn.Small, "Dodaj komentarz", undefined, disableBtn)}></ButtonField>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    );
}

export default SecondaryCommentCard;